import { ApiManager } from 'utlis/api_manager';
import http from 'utlis/http';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);

const designAuditApi = process.env.REACT_APP_DESIGN_AUDIT_BASE_URL
  || 'https://uae-feedback-gen.designpro.ai/staging';

export default class WebDashboardReviews {
  static async submitReview({ figmaUrl, imageUrls, product, title, authUser = null, hasTAMMGuideline = true }) {
    const payload = {
      product,
      title,
      hasTAMMGuideline,
    };

    // Add figma_url or image_urls based on what's available
    if (figmaUrl) {
      payload.figma_url = figmaUrl;
    }

    if (imageUrls && imageUrls.length > 0) {
      payload.image_urls = imageUrls;
    }

    if (authUser.uuid) {
      payload.user_uuid = authUser.uuid || null;
    }

    return http.post(`${designAuditApi}/webdashboard_reviews`, payload);
  }
}

export const getSingleDesignAudit = async designUuid => {
  const url = `project/design-audits/${designUuid}`;

  try {
    const { data } = await api.setUrl(url).get();

    return data;
  }
  catch (e) {
    console.error(e);

    throw e;
  }
};

export const getPdfDownloadUrl = async pdfKey => {
  const url = 'project/get_pdf_download_url';

  try {
    const { data } = await api.setUrl(url).get({ pdf_key: pdfKey });

    return data;
  }
  catch (e) {
    console.error('Error getting PDF download URL:', e);

    throw e;
  }
};
